import { differenceInCalendarDays } from 'shared/util/datetime-fns';

import type { HotelRoom } from '../types/HotelRoom';

interface ValidationResult {
    isValid: boolean;
    invalid: {
        destination: boolean;
        rooms: boolean;
        startDate: boolean;
        endDate: boolean;
        dateRange: boolean;
    };
}

export const useHotelValidation = (
    {
        destination,
        destinationContext,
        rooms = [],
        startDate,
        endDate,
    }: {
        destination?: string;
        destinationContext?: unknown;
        rooms?: HotelRoom[];
        startDate?: Date;
        endDate?: Date;
    },
    pristine: boolean,
    unleash?: Record<string, boolean>,
): ValidationResult => {
    const roomsAreValid = () => !rooms.some((room) => room.adults + room.children.length === 0);
    const datesAreOk = () => !!startDate && !!endDate && differenceInCalendarDays(startDate, endDate) <= 30;
    const datesAreClear = () => !startDate && !endDate;
    const datesAreValid = () => datesAreOk() || (!unleash?.kayakWhitelabel && datesAreClear());
    const invalidDate = (thisDate?: Date, otherDate?: Date) => (!thisDate && otherDate) || (unleash?.kayakWhitelabel && !thisDate);

    const invalid = {
        destination: !!(!pristine && (!destination || !destinationContext)),
        rooms: !!(!pristine && !roomsAreValid()),
        startDate: !!(!pristine && invalidDate(startDate, endDate)),
        endDate: !!(!pristine && invalidDate(endDate, startDate)),
        dateRange: !!(!pristine && startDate && endDate && differenceInCalendarDays(startDate, endDate) > 30),
    };

    const isValid = datesAreValid() && roomsAreValid() && destination && destinationContext;

    return { isValid: !!isValid, invalid };
};
